module.exports = __webpack_public_path__ + "static/media/knee X-ray Chart.0747464a.png";